import { render, staticRenderFns } from "./ResultsHorizontal.vue?vue&type=template&id=267ed392&scoped=true&"
import script from "./ResultsHorizontal.vue?vue&type=script&lang=js&"
export * from "./ResultsHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./ResultsHorizontal.vue?vue&type=style&index=0&id=267ed392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267ed392",
  null
  
)

export default component.exports